import AnnouncementsHeadSection from "./sections/AnnouncementsHeadSection/AnnouncementsHeadSection";
import AnnouncementsGridSection from "./sections/AnnouncementsGridSection/AnnouncementsGridSection";

const AnnouncementsPage = () => {
  return (
    <>
      <AnnouncementsHeadSection />
      <div className="rbt-counterup-area rbt-section-overlayping-top rbt-section-gapBottom">
        <div className="container">
          <AnnouncementsGridSection />
        </div>
      </div>
    </>
  );
};

export default AnnouncementsPage;
